import { ReactNode } from 'react'

interface LayoutProps {
  children: ReactNode
}

export const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-white border-b border-gray-200 shadow-sm">
        <nav className="max-w-5xl mx-auto px-4 min-h-[70px] flex items-center justify-center">
          <div className="flex items-center gap-[10px] md:gap-3">
            <img 
              src="/logo/logo-glossy.png" 
              alt="RiverBlue logo" 
              className="h-12 w-12 md:h-14 md:w-14 object-contain"
              style={{
                filter: 'drop-shadow(0 0 20px rgba(59, 130, 246, 0.4)) drop-shadow(0 0 40px rgba(59, 130, 246, 0.3)) brightness(1.1) contrast(1.05) saturate(1.1)',
              }}
            />
            <span className="text-[18px] md:text-[20px] font-semibold text-gray-900" style={{ fontWeight: 600 }}>
              RiverBlue
            </span>
          </div>
        </nav>
      </header>
      <main className="flex-1">
        {children}
      </main>
      <footer className="text-center py-8 px-4 text-gray-600 text-xs md:text-sm border-t border-slate-200 mt-16">
        <div className="max-w-5xl mx-auto">
          <div className="mb-2">
            <a href="/privacy-policy" className="text-gray-600 hover:text-gray-900 underline mr-4">Privacy Policy</a>
          </div>
          © 2026 riverblue ventures, LLC. All rights reserved.
        </div>
      </footer>
    </div>
  )
}
